export interface VerifiableAddress {
    address1?: string
    apartmentHouseNumber?: string
    zipCode?: string
    city?: string
    state?: string
    country?: string
}

const normalise = (value: string | undefined): string =>
    (value ?? "").trim().toLowerCase().replace(/\s+/g, " ")

/**
 * Identity for the deliverable part of an address, insensitive to case and spacing, so a
 * later submit can recognise one Loqate already resolved. Name and contact details are
 * excluded: they do not affect deliverability.
 */
export const addressVerificationKey = (address: VerifiableAddress): string =>
    [
        normalise(address.address1),
        normalise(address.apartmentHouseNumber),
        normalise(address.zipCode),
        normalise(address.city),
        normalise(address.state),
        normalise(address.country)
    ].join("|")

/**
 * Whether submitting this address should cost a Verify call. `verifiedKey` is the last
 * address Loqate resolved; editing any deliverable field re-arms verification.
 */
export const needsAddressVerification = (
    address: VerifiableAddress,
    verifiedKey: string | null
): boolean => verifiedKey !== addressVerificationKey(address)
